module.exports = __webpack_public_path__ + "img/b83afbe.png";